"use client";

import Image from "@/components/Image";
import type { ReactNode } from "react";
import { createPortal } from "react-dom";

type ModalPosition = "center" | "left" | "right";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  position?: ModalPosition; // Optional prop to set the position
}

function getPositionClasses(position: string) {
  switch (position) {
    case "left":
      return "md:justify-start";
    case "right":
      return "md:justify-end";
    case "center":
      return "md:justify-center";
    default:
      return "md:justify-center";
  }
}

export function Modal({
  isOpen,
  onClose,
  children,
  position = "center",
}: ModalProps) {
  if (!isOpen) {
    return null;
  }

  return createPortal(
    <div
      id="modal"
      className="fixed inset-0 z-[9999] flex items-center  pointer-events-auto"
      onClick={onClose} // Close modal when clicking on the backdrop
    >
      <div className="fixed inset-0 z-10 md:backdrop-blur-lg bg-white md:bg-transparent backdrop"></div>
      {/* Modal Wrapper */}
      <div
        className={`z-20 relative flex w-screen h-full justify-center modal-content ${getPositionClasses(
          position
        )}`}
      >
        <button
          type="button"
          className="block md:hidden absolute top-6 right-4 p-[10px] rounded-full border border-solid border-[#E6E8EC]"
          onClick={onClose} // Optional close button inside modal
        >
          <Image
            src={require("@/assets/svg/close_line.svg")}
            className="w-full h-full object-cover"
            alt="close"
            width={20}
            height={20}
          />
        </button>
        {/* Modal Content */}
        <button
          type="button"
          className="py-6 px-2 overflow-auto"
          onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside modal content
        >
          {children}
        </button>
      </div>
    </div>,
    document.body
  );
}
